var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginPageKaskoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgexport-6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.922,
    height: 38.252,
    viewBox: "0 0 54.922 38.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11817",
    "data-name": "Group 11817",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5337",
    "data-name": "Path 5337",
    d: "M14.794,30.237l-4.377-.944A1.93,1.93,0,0,0,8.1,31.181v1.8c0,1.459,1.116,1.8,2.489,1.8h4.806c.944,0,1.888-.172,1.888-1.2v-.257a3.063,3.063,0,0,0-2.489-3.089ZM9.731,32.983V31.1c0-.172.172-.343.343-.257l4.377.944a1.569,1.569,0,0,1,1.116,1.287c-3,0-5.578,0-5.835-.086Z",
    transform: "translate(-1.149 -12.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5338",
    "data-name": "Path 5338",
    d: "M52.605,18.282l-6.179-2.918a10.5,10.5,0,0,0-6.436-.858l-.944-1.888a4.561,4.561,0,0,0-4.2-2.918H14.76a4.483,4.483,0,0,0-4.2,2.832L7.209,19.483a4.192,4.192,0,0,0-3.433-1.8H2.317A2.307,2.307,0,0,0,0,20v.944a2.307,2.307,0,0,0,2.317,2.317H4.548A6.929,6.929,0,0,0,3.175,27.55V32.7a8.417,8.417,0,0,0,2.06,5.492v3.862a3.077,3.077,0,0,0,3.089,3.089H11.5a3.077,3.077,0,0,0,3.089-3.089V40.508H31.752a23.345,23.345,0,0,0,9.783,7.38.726.726,0,0,0,.6,0c.086-.086,12.787-4.72,12.787-16.305V21.972a4.212,4.212,0,0,0-2.317-3.69ZM12.1,13.218a2.791,2.791,0,0,1,2.66-1.8H34.841A2.942,2.942,0,0,1,37.587,13.3l.772,1.631a5.249,5.249,0,0,0-1.03.429l-6.179,2.918a4.083,4.083,0,0,0-2.317,3.6H7.809c.343-.515,0,.343,4.291-8.667ZM1.716,20.942V20a.587.587,0,0,1,.6-.6H3.776a2.859,2.859,0,0,1,2.489,1.8,1.507,1.507,0,0,1-.343.429h-3.6a.728.728,0,0,1-.6-.687ZM12.872,41.967A1.355,1.355,0,0,1,11.5,43.34H8.238a1.306,1.306,0,0,1-1.373-1.373V39.478a6.88,6.88,0,0,0,3.433.944h2.574Zm-2.66-3.175c-3.089,0-5.492-3-5.492-6.179V27.464A5.817,5.817,0,0,1,6.35,23.516H28.834v7.552h-9.44a.86.86,0,0,0-.858.858.811.811,0,0,0,.858.858H28.92a9.262,9.262,0,0,0,.257,1.631H19.394a.86.86,0,0,0-.858.858.811.811,0,0,0,.858.858H29.521a12.545,12.545,0,0,0,1.2,2.66Zm42.994-7.209c0,9.526-9.611,13.9-11.328,14.589C35.7,43.683,30.55,38.363,30.55,31.583V21.972a2.349,2.349,0,0,1,1.373-2.145L38.1,16.909a8.726,8.726,0,0,1,7.723,0L52,19.826a2.5,2.5,0,0,1,1.373,2.145v9.611Z",
    transform: "translate(0 -9.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5339",
    "data-name": "Path 5339",
    d: "M55.735,23.254l-5.664-2.66a6.365,6.365,0,0,0-5.578,0l-5.578,2.66a.986.986,0,0,0-.515.772v9.011c0,6.779,5.921,10.47,8.5,11.757a1.191,1.191,0,0,0,.772,0c2.574-1.287,8.5-4.977,8.5-11.757V24.026a.9.9,0,0,0-.429-.772Zm-1.2,9.783c0,5.492-4.806,8.753-7.209,10.04-2.832-1.545-7.209-4.634-7.209-10.04v-8.5l5.149-2.489a4.933,4.933,0,0,1,4.119,0l5.149,2.489Z",
    transform: "translate(-5.447 -11.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5340",
    "data-name": "Path 5340",
    d: "M44.671,34.251a.935.935,0,0,0-1.2.172.848.848,0,0,0,.172,1.2L46.9,38.113a.935.935,0,0,0,1.2-.172l4.806-6.265a.858.858,0,0,0-1.373-1.03l-4.291,5.578Z",
    transform: "translate(-6.139 -12.626)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageKaskoIcon);
export default __webpack_public_path__ + "static/media/login-page-kasko-icon.117aca0bfc9c22cb30496054cafeb37f.svg";
export { ForwardRef as ReactComponent };